import React from 'react'
import './App.css'
import Navbar from './components/Navbar'
import Container from './components/Container'
// import axios from 'axios'
import QuotesData from './QuotesData'

function App() {
  const [items, setItems] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(true)
  React.useEffect(() => {
    const fetchItems = async () => {
      // const result = await axios(`http://officeapi.dev/api/quotes`)
      setItems(QuotesData.data)
      // console.log(items)
      setIsLoading(false)
    }

    fetchItems()
  })

  return (
    <div className='body'>
      <Navbar />
      <Container items={items} isLoading={isLoading} />
    </div>
  )
}

export default App
